<template lang="pug">
    //crud-create-button( v-bind="createButtonProps" v-if="$can("CREATE_PREVISION")" )
    model-data-table(
        no-data-text="Sin previsiones."
        :no-detail="! $can( 'VIEW_DETAIL_PREVISION' )"
        :no-remove="! $can( 'DELETE_PREVISION' )"
        param-search="name"
        ref="table"
        remind-key='prevision-list'
        v-bind="tableProps"
        @detail="submitUpdate"
        @remove="submitRemove"
    )
</template>

<script>
//
import { mapActions, mapState } from "vuex"
import { ModelDataTable } from "@/components/reusable_components/next"
//
import PrevisionModel from "@/models/HumanResource/HrPrevision"
import { PrevisionHeaders } from "@/views/HumanResource/HrPrevision/headers"
import PrevisionFilters from '@/views/HumanResource/HrPrevision/HrPrevisionFilters'
//
export default {
    name: "prevision-list",
    components: {
        ModelDataTable,
    },
    computed: {

        /**
         *
         */
        ...mapState("SnackbarModalModule", [
            "responseConfirm",
        ]),

        /**
         *
         */
        tableProps () {
            return {
                filters: PrevisionFilters,
                headers: PrevisionHeaders,
                service: PrevisionModel,
            }
        },

        /**
         * 
         */
        toolbarItems () {
            return [
                {
                    text    : "crear prevision",
                    icon    : "add_circle",
                    action  : this.submitCreate,
                }
            ]
        }
    },
    data () {
        return {
            selected: null,
        }
    },
    methods: {

        /**
         *
         */

        ...mapActions("MenuesModule", [
            "setItemsTopBar",
            "setTitleTopBar",
        ]),

        /**
         *
         */
        ...mapActions("SnackbarModalModule", [
            "setErrorSnackbar",
            "setSuccessSnackbar",
            "setWarningSnackbar",
        ]),

        /**
         * 
         */
        error () {
            this.setSuccessSnackbar( "No se pudo eliminar la prevision." )
        },

        /**
         * 
         */
        refresh () {
            this.$refs.table.refresh()
        },

        /**
         * 
         */
        remove () {
            this.selected.delete().then( this.refresh ).then( this.success ).catch( this.error )
        },

        /**
         *
         */
        reset () {
            this.setItemsTopBar( this.toolbarItems )
            this.setTitleTopBar( "Previsiones" )
        },

        /**
         *
         */
        submitCreate () {
            this.$router.push({ name: "prevision-create" })
        },

        /**
         *
         */
        submitRemove ( event ) {

            //
            this.setWarningSnackbar({
                title: "Eliminar previson",
                message: "¿Desea eliminar la prevision?",
                confirm: "eliminar prevision",
            })

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitUpdate ( event ) {
            this.$router.push({ name: "prevision-detail", params: { id: event.item.id } })
        },

        /**
         * 
         */
        success () {
            this.setSuccessSnackbar( "Prevision eliminada existosamente." )
        },
    },
    mounted() {
        this.reset()
    },
    watch: {

        /**
         *
         */
        async responseConfirm( val ) {
            switch ( val ) {
                case "eliminar prevision": return this.remove();
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can("VIEW_ALL_PREVISION")) ctx.$router.push("/")
        })
    },
}
</script>

